export const messages = {
  placeholder: 'Ближайший населённый пункт',
  errors: {
    required: 'Выберите ближайший населенный пункт к месту ведения бизнеса',
  },
}
